
import { defineComponent, PropType } from 'vue';
import Cleave from 'cleave.js';

export default defineComponent({
  name: 'TextInput',
  emits: ['update:modelValue'],
  data() {
    return {
      cleave: null as Cleave | null,
      value: '',
    };
  },
  props: {
    modelValue: String,
    placeholder: String,
    error: Boolean,
    type: {
      type: String as PropType<'tel' | 'email' | 'text' | 'password' | 'textarea'>,
      required: true,
      default: () => 'text',
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('update:modelValue', newValue);
      }
    },
    modelValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.value = newValue;
      }
    },
  },
  mounted() {
    if (this.type === 'tel') {
      this.cleave = new Cleave(this.$refs.input as HTMLElement, {
        phone: true,
        phoneRegionCode: 'RU',
        onValueChanged: (e: Event) => {
          this.$emit('update:modelValue', (e.target as any).rawValue);
        },
      });
    }
  },
});
